module.exports = __webpack_public_path__ + "media/images/redesign-images/corporate/business/bus-product-5-d93dbaba9f4ac7ab42d06ac3c6d0a67b.jpg";